import { Container, Typography } from '@cleartrip/ct-design-components'
import { filterTypes } from '@/constants/Srp'
import CheckboxItem from './checkboxItem'
import FilterJourneyInfo from './FilterJourneyInfo'

const CheckInBaggageFilter = ({
  onFilterChange,
  fareInclusions,
  from,
  to,
  isRT,
  legIsOnward,
  isRevamp = false,
}: {
  onFilterChange: any
  fareInclusions: any
  from: string
  to: string
  isRT: boolean
  legIsOnward: boolean
  isRevamp?: boolean
}) => {
  const { label, value } = fareInclusions?.options?.[0] || {}
  const checked = fareInclusions?.selectedValues?.includes('withBaggage')
  const checkInBaggageText = 'Include check-in baggage'
  const onCheckInBaggageClick = () => {
    onFilterChange(
      filterTypes.CHECK_IN_BAGGAGE,
      !checked ? ['withBaggage'] : [],
      legIsOnward ? 0 : 1,
      legIsOnward ? 'onwardLeg' : 'returnLeg'
    )
  }

  return (
    <Container className={isRevamp ? 'flex flex-column' : 'py-3'}>
      <FilterJourneyInfo from={from} to={to} isRT={isRT} isRevamp={isRevamp} />
      <CheckboxItem
        key={value}
        label={
          <Typography variant='P2' className='c-pointer'>
            {checkInBaggageText}
          </Typography>
        }
        checked={checked}
        onClick={() => onCheckInBaggageClick()}
        wrapperClassName={'py-2 w-100p checkbox-hover-border'}
      />
    </Container>
  )
}

export default CheckInBaggageFilter
